import React from "react";
import { isNullOrEmpty, isNullOrLengthIsZero } from "shared/Helpers";
import { Box, Typography } from "@mui/material";

export default function ErrorListToast(props) {
  return (
    <>
      <Typography variant="p" sx={{ display: "block", fontWeight: "bold" }}>
        {props.errorTitle}
      </Typography>
      {!isNullOrEmpty(props.errorBody) && (
        <Typography variant="p" sx={{ display: "block", mt: 1 }}>
          {props.errorBody}
        </Typography>
      )}
      {!isNullOrLengthIsZero(props.errorList) && (
        <Box
          sx={{
            display: "block",
            maxHeight: "100px",
            backgroundColor: "#ffffff",
            borderRadius: 1,
            overflowY: "scroll",
            color: "#000000",
            p: 1,
            mt: 2,
          }}
        >
          {props.errorList.map((errorText, index) => {
            return (
              <Typography key={"error-" + index} sx={{ mb: 1 }}>
                {errorText}
              </Typography>
            );
          })}
        </Box>
      )}
    </>
  );
}
